import { siteConfig } from "./config/site";

/**
 * Plantilla alineada con requirements/CONTENT-AUTHORING.md
 * Variables: nombre, precio, SKU.
 */
export function buildWhatsAppProductUrl(productName: string, priceLabel: string, sku: string): string {
  const phone = siteConfig.contact.whatsappE164;
  const text = `Hola, Hikarai 👋 Quiero comprar: ${productName} — ${priceLabel} (SKU: ${sku}). ¿Está disponible y cómo pago/retiro en Medellín?`;
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}

export function buildWhatsAppGeneralUrl(presetMessage?: string): string {
  const phone = siteConfig.contact.whatsappE164;
  const text =
    presetMessage ??
    "Hola, Hikarai 👋 Quiero ver qué hay en stock y cómo retiro en Medellín.";
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}

/** Preventa Mystery Box The Apothecary Diaries — portada próximamente (Stitch). */
export function buildWhatsAppApothecaryMysteryBoxPreorderUrl(): string {
  const phone = siteConfig.contact.whatsappE164;
  const text =
    "Hola, Hikarai 👋 Quiero reservar en preventa 1 Mystery Box de The Apothecary Diaries (Los diarios de la boticaria / Kusuriya no Hitorigoto). Es una de las 10 unidades. ¿Me confirman precio, disponibilidad y cómo pago o envío?";
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}
